import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useHeaderBackground } from "./useHeaderBackground";
import { Sx } from "utils/sx";
import { SearchEventAndOrganisationInput } from "./SearchEventAndOrganisationInput";

const headerStyle: Sx = (theme) => ({
    width: "calc(100vw - ( 100vw - 100% ) )",
    maxWidth: "100vw",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    height: theme.spacing(72),
    [theme.breakpoints.down("lg")]: {
        height: theme.spacing(58),
    },
    [theme.breakpoints.down("md")]: {
        height: theme.spacing(48),
    },
    display: "flex",
    alignItems: "center",
    justifyItems: "stretch",
    position: "relative",
    "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.2)",
        zIndex: 0,
    },
});

const titleAndSearchContainerStyle: Sx = (theme) => ({
    flex: 1,
    padding: theme.spacing(2),
    zIndex: 1,
});

const searchBoxStyle: Sx = (theme) => ({
    margin: "auto",
    maxWidth: theme.spacing(150),
    minWidth: 0,
    padding: theme.spacing(2),
    position: "relative",
    backdropFilter: `blur(${theme.spacing(1.5)})`,
    borderRadius: theme.spacing(1.5),
    overflow: "hidden",
    "&::before": {
        content: '""',
        position: "absolute",
        backgroundColor: theme.palette.background.low,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        opacity: 0.75,
        zIndex: 0,
        pointerEvents: "none",
    },
});

const searchInputContainerStyle: Sx = {
    position: "relative",
    zIndex: 1,
};

const backgroundImageStyle: Sx = (theme) => ({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundColor: theme.palette.brand.tertiary,
    opacity: 0,
    transition: "opacity 150ms ease-in-out",
});

export const Header = () => {
    const theme = useTheme();
    const { background, backgroundColor, imageLoaded } = useHeaderBackground();

    return (
        <Stack sx={[headerStyle, { backgroundColor }]} direction="row">
            <Box
                sx={[
                    backgroundImageStyle,
                    {
                        backgroundImage: `url(${background})`,
                        opacity: imageLoaded ? 1 : 0,
                    },
                ]}
            />
            <Box sx={titleAndSearchContainerStyle}>
                <Typography
                    variant="brandHomepageHero"
                    color="textContrastText"
                    component="h1"
                    sx={(theme) => ({
                        margin: "auto",
                        maxWidth: theme.spacing(150),
                    })}
                >
                    <span style={{ color: theme.palette.secondary.main }}>
                        Make
                    </span>{" "}
                    action sports{" "}
                    <span style={{ color: theme.palette.secondary.main }}>
                        history
                    </span>
                    .
                </Typography>
                <Box sx={searchBoxStyle}>
                    <Box sx={searchInputContainerStyle}>
                        <SearchEventAndOrganisationInput />
                    </Box>
                </Box>
            </Box>
        </Stack>
    );
};
